(function() {
  $('[id^="ProductPhotos-"]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: false,
    nextArrow: false,
    dots: true
  });
  
  $('#radiotabs > li').click(function() {
    $(this).parent().each(function( index ) {
      $(this).find('a').addClass('inactive');
    });
    $(this).find('a').removeClass('inactive');
    let selectedID = $(this).find('a').attr('id');
    $('.radio-tabs-container').hide();
    $('#'+selectedID+'C').css({'opacity':'0'}).fadeTo(500, 1);;
  });
  
  $('.modal-trigger').click(function () {
    let modal = $(this).data('modal');
    $('#'+modal).show();
  });
  $('.close-modal').click(function() {
    $('.modal').css({'display':'none'});
  });
  $('.modal-sandbox').click(function() {
    $('.modal').css({'display':'none'});
  });
  
  $('.review-slider').slick({
        dots: true,
        arrows:true,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              variableWidth: true,
              arrows:false,
            }
          }
        ]
      });
  $("div.swatch-element").click(function(el) {
    $(".swatch-element").removeClass("checked");
    $('div[data-id="'+$(this).data('id')+'"]').addClass("checked");
    let $input = $(this).find('input');
    let price = $input.data('price');
    let comparePrice = $input.data('compare-price');
    let plainPrice = price.replace('€','').replace(',','.');
    let plainComparePrice = comparePrice.replace('€','').replace(',','.');
    var priceLabel = parseFloat($('.variant-price').first().text().replace('€','').replace(',','.'));
    //let percentage = '{{ discount_percentage }}';
    
    $input.prop("checked", true);
    //$('.discount-price').text($input.data('price'));

    //$(".regular-price-discounted").remove();
    $('.variant-price').text(price);
    $('.min_price').text(" €"+($input.data('unit-price')/100).toFixed(2).replace('.',','));
    
    // show/hide delivery costs
    if (price.replace('€','').replace(',','.') < 20) {
      
    } else {
      
    }
    
    let id = $(this).attr('id');
    console.log(id);
    
    if (id == "neobomi-apfelstammzellen-hyaluron-maske-variation-1") {
      $('.discounted-apfel-price').text($(this).find('input').data('price'));
      $('.offer-strike').hide();
      $('.discount-img').hide();
      $('.offer-number').text('2');
      if ($('#upsell-prod:checked').length > 0) {
        priceLabel = 18.95 + 9.95;
      } else {
        priceLabel = 18.95;
      }
      $('.variant-price').text("€"+priceLabel.toFixed(2).toString().replace('.',','));
    } else if (id == "neobomi-apfelstammzellen-hyaluron-maske-variation-2") {
      $('.discounted-apfel-price').text($(this).find('input').data('price'));
      $('.offer-strike').html('statt <b><s>€42,38</s></b>');
      $('.offer-strike').show();
      $('.discount-img').attr("src","https://cdn.shopify.com/s/files/1/0246/1623/9167/files/40-discount.png?v=1592483746").show();
      $('.offer-number').text('5');
      if ($('#upsell-prod:checked').length > 0) {
        priceLabel = 37.95 + 9.95;
      } else {
        priceLabel = 37.95;
      }
      $('.variant-price').text("€"+priceLabel.toFixed(2).toString().replace('.',','));
    } else if (id == "neobomi-apfelstammzellen-hyaluron-maske-variation-3") {
      if ($('#upsell-prod:checked').length > 0) {
        priceLabel = 19.95 + 9.95;
      } else {
        priceLabel = 19.95;
      }
      $('.variant-price').text("€"+priceLabel.toFixed(2).toString().replace('.',','));
    } else if (id == "neobomi-apfelstammzellen-hyaluron-maske-variation-4") {
      $('.discounted-apfel-price').text($(this).find('input').data('price'));
      $('.offer-strike').html('statt <b><s>€84,75</s></b>');
      $('.offer-strike').show();
      $('.discount-img').attr("src","https://cdn.shopify.com/s/files/1/0246/1623/9167/files/47-discount.png?v=1592483746").show();
      $('.offer-number').text('10');
      if ($('#upsell-prod:checked').length > 0) {
        priceLabel = 44.95 + 9.95;
      } else {
        priceLabel = 44.95;
      }
      $('.variant-price').text("€"+priceLabel.toFixed(2).toString().replace('.',','));
    } else if (id == "apfelstammzellen-hyaluron-tuchmasken-variation-1") {
      $('.discounted-apfel-price').text($(this).find('input').data('price'));
      $('.offer-strike').hide();
      $('.discount-img').hide();
      $('.offer-number').text('2');
      if ($('#upsell-prod:checked').length > 0) {
        priceLabel = 16.95 + 9.95;
      } else {
        priceLabel = 16.95;
      }
      $('.variant-price').text("€"+priceLabel.toFixed(2).toString().replace('.',','));
    } else if (id == "apfelstammzellen-hyaluron-tuchmasken-variation-2") {
      $('.discounted-apfel-price').text($(this).find('input').data('price'));
      $('.offer-strike').html('statt <b><s>€37,95</s></b>');
      $('.offer-strike').show();
      $('.discount-img').attr("src","https://cdn.shopify.com/s/files/1/0246/1623/9167/files/34-discount.png?v=1594312994").show();
      $('.offer-number').text('5');
      if ($('#upsell-prod:checked').length > 0) {
        priceLabel = 24.95 + 9.95;
      } else {
        priceLabel = 24.95;
      }
      $('.variant-price').text("€"+priceLabel.toFixed(2).toString().replace('.',','));
    } else if (id == "apfelstammzellen-hyaluron-tuchmasken-variation-3") {
      $('.discounted-apfel-price').text($(this).find('input').data('price'));
      $('.offer-strike').html('statt <b><s>€74,95</s></b>');
      $('.offer-strike').show();
      $('.discount-img').attr("src","https://cdn.shopify.com/s/files/1/0246/1623/9167/files/40-discount.png?v=1592483746").show();
      $('.offer-number').text('10');
      if ($('#upsell-prod:checked').length > 0) {
        priceLabel = 44.95 + 9.95;
      } else {
        priceLabel = 44.95;
      }
      $('.variant-price').text("€"+priceLabel.toFixed(2).toString().replace('.',','));
    } else if (id == "apfelmasken-set-save" || id == "apfelmasken-single-mix" || id == "apfelmasken-facial-spa") {
      $('.discounted-apfel-price').text($(this).find('input').data('price'));
      $('.discount-img').hide();
      $('.offer-number').text('2');
      if (id == "apfelmasken-set-save") {
        $('.offer-strike b s').text('€74,95');
        $('.base-price').text('(20,43 € / 100 ml) inkl. MwSt.');
        $('.first-info').html('10 Sachets für €44,95. <b>40% Ersparnis.</b>');
        $('.second-info').html('Kleine Überraschung.');
        $('.third-info').hide();
      } else if (id == "apfelmasken-facial-spa") {
        $('.offer-strike b s').text('€149,95');
        $('.base-price').text('(22,21 € / 100 ml) inkl. MwSt.');
        $('.first-info').html('20 Sachets der Hyaluron <b>Maske</b>');
        $('.second-info').html('50 ml Clay Jojoba-Hyaluron <b>Peeling</b>');
        $('.third-info').show();
      } else {
        $('.offer-strike b s').text('€37,95');
        $('.base-price').text('(22,68 € / 100 ml) inkl. MwSt.');
        $('.first-info').html('5 Sachets für €24,95. <b>34% Ersparnis.</b>');
        $('.second-info').html('Kleine Überraschung.');
        $('.third-info').hide();
      }
      $('.variant-price').text("€"+priceLabel.toFixed(2).toString().replace('.',','));
    }
    
    // change onclick function of fixed atc btn
    $(".fixed-atc-btn").attr("onclick","addtoCartX("+$(this).data('id')+")");
    
    /*if ($input.data('compare-price').length > 0 && $input.data('compare-price') != "€0,00") {
      $('<span class="regular-price-discounted">'+ $input.data('compare-price') +'</span>').insertBefore('.discount-price');
    }
    showDiscountLine();*/
  });
  
  $('[id^="AddToCartForm-"]').submit(function (e) {
    e.preventDefault();
    let serialized = $(this).serializeArray();
    
    $(serialized).each(function(i, field){
      if (field.name == "id") {
        console.log(field.value);
        if ($('input[name=page_source]').length != 0) {
          addtoCartX(parseInt(field.value), $("input[name=page_source]").val());
        } else {
          addtoCartX(parseInt(field.value));
        }
      }
    });
  });
  $('[id^="RelatedAddToCartBtn-"]').submit(function (e) {
    e.preventDefault();
    addtoCartX($(this).data('productid'));
  });
  $('.upsell-product').click(function () {
    console.log("upsell clicked");
    $(this).find('[type=checkbox]').prop("checked", !$(this).find('[type=checkbox]').prop("checked")).change();
    var price = parseFloat($('.variant-price').first().text().replace('€','').replace(',','.'));
    if ($(this).find('[type=checkbox]:checked').length > 0) {
      price = price + 9.95;
    } else {
      price = price - 9.95;
    }
    $('.variant-price').text("€"+price.toFixed(2).toString().replace('.',','));
  });
})();
$(document).ready(function(){
  $('.fixed-bottom-bar').slideUp('fast');
  setTimeout(function() {
  fbq('trackCustom', $('body').attr('class'));
  }, 2000);
});
$(window).scroll(function(){
  if (isVisible($('.add-to-cart-wrapper'), $(window))){
    if ($('.fixed-bottom-bar').length > 0 && $('.is-mobile').is(':hidden')) {
      $('.fixed-bottom-bar').slideUp('fast');
    }
  } else {
    if ($('.fixed-bottom-bar').length > 0 && $('.is-mobile').is(':hidden')) {
      $('.fixed-bottom-bar').slideDown('fast');
    }
  }
});
function isVisible( row, container ){
  if (!row.length)
    return false;

  var elementTop = $(row).offset().top,
    elementHeight = $(row).height(),
    containerTop = container.scrollTop(),
    containerHeight = container.height();
    
  return ((((elementTop - containerTop) + elementHeight) > 0) && ((elementTop - containerTop) < containerHeight));
}